import { humanizeWireValue } from 'syft-acp-core/components/SchedulingPlanDialog'
import type { AgencyJobHistoryEntry } from 'syft-acp-core/store/agency-jobs-history/types'

type TagStatus = 'info' | 'warning' | 'neutral'

// Labels for the statuses known so far. flex-core has not documented the full set, so anything
// else falls back to a readable form of the raw value.
const knownStatuses: Record<string, { label: string; tagStatus: TagStatus }> = {
  awaiting_response: { label: 'Awaiting response', tagStatus: 'neutral' },
  holding: { label: 'Holding job', tagStatus: 'info' },
  declined: { label: 'Declined', tagStatus: 'neutral' },
  cascaded: { label: 'Cascaded', tagStatus: 'warning' },
  ended: { label: 'Ended', tagStatus: 'neutral' },
}

export const getAgencyJobStatusTag = (status: string): { label: string; tagStatus: TagStatus } =>
  knownStatuses[status] ?? { label: humanizeWireValue(status), tagStatus: 'neutral' }

/** Live means neither declined nor ended, read from the timestamps rather than the status. */
export const isLiveAgencyJob = (agencyJob: AgencyJobHistoryEntry) =>
  !agencyJob.declined_at && !agencyJob.ended_at

export const formatShiftCount = (count: number) => `${count} shift${count === 1 ? '' : 's'}`

export const formatAgencyRank = (rank: number | null) => (rank === null ? 'Unranked' : `Rank ${rank}`)
